export const getStaticSiteUrl = () => {
  const { protocol, host } = window.location;

  return `${protocol}//${host.replace('secure.', '')}`;
};
